import React from "react"
import Video from "../../video/Video"
import Figure from "../figure"


const Cemetery = () => {
  
  return (
    <Figure
      caption="Drone footage of the migrant cemetery in Libya where Candé was buried."
      date="May 23, 2021"
    >
      <Video
        src="https://cdn.theoutlawocean.com/al-mabani/footage__cemetery.mp4"
        customPadding="57.14%"
        muted="muted"
        autoplay="autoplay"
      />
    </Figure>
  );
};
export default Cemetery;
export { Cemetery };